import { Component, Inject, OnInit } from '@angular/core';
import { RegistrationResponse } from '../registration-response';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { ApiRequestService } from '../../shared/api-request-service';
import { DataDialog } from '../verification/dataDialog';
import { SigninComponent } from '../signin/signin.component';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { HttpError } from '../../shared/httperror';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslationService } from '../../translation/translation.service';

@Component({
    selector: 'pw-verification-forgot-password',
    templateUrl: './verification-forgot-password.component.html',
    styleUrls: ['./verification-forgot-password.component.scss']
})
export class VerificationForgotPasswordComponent implements OnInit {
    loginBaseUrl = '';
    verificationUrl = '/verification-forgotpassword';
    verificationUuid = '';
    registrationResponse: RegistrationResponse = {};

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    dataDialog?:DataDialog = {};


    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    constructor(
        private readonly breakpointObserver: BreakpointObserver,
        private _matDialog: MatDialog,
        @Inject('AUTH_BACKEND_URL') private _loginUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService:ToastmessageService,
        private _router: Router,
        private _translateService: TranslationService,
    ) {
        this.loginBaseUrl = _loginUrl;
        this.isExtraSmall= this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall= this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }



    ngOnInit(): void {
        this.verificationUuid = window.location.href.split('/').pop() as string;
        this._apiRequestService
            .downloadJsonRequest(this.loginBaseUrl + this.verificationUrl + '/' + this.verificationUuid)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        this._toastMessageService.displayToastMessage(TOAST_STATE.warning, this._translateService.translate('login.verificationUuidExpired'),MAT_ICON.warning);
                        this._router.navigateByUrl('/');
                        //close toast message
                        this.dismissError();


                    })
                })
            )
            .subscribe((answer) => {
                this.registrationResponse = answer as RegistrationResponse;
                //this._toastMessageService.displayToastMessage(TOAST_STATE.success,this.registrationResponse.message!,MAT_ICON.success);
                //this.dismissError();
                 //TODO beléptetni!!! hívni oauth2/token kell hozzá jelszó, email cím
                this.dataDialog = {
                    verificationUuid:this.verificationUuid,
                    message:this.registrationResponse.message,
                    email:this.registrationResponse.email
                }
                const popupDialog = this._matDialog.open(ForgotpasswordComponent, {
                    data: this.dataDialog,
                    width: 'calc(100% - 50px)',
                    maxWidth: '100vw',
                    height: '80%'
                });
                const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
                    if (size.matches) {
                        popupDialog.updateSize('100vw', '100%');
                    } else {
                        popupDialog.updateSize('calc(60% - 50px)', '');
                    }
                });

                popupDialog.afterClosed().subscribe(() => {
                    xsmallDialogSubscription.unsubscribe();
                });

            });

    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }
}
